module.exports = __webpack_public_path__ + "04_face.53f02f06.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer1/04_face.png
// module id = j6Qb
// module chunks = 0